<div class="databases">
  @if (filteredDatabases$ | async; as records) {
    <app-search-field
      placeholder="Search"
      id="record-search"
      (searchText)="onSearch($event)"
    ></app-search-field>

    <div class="table-container">
      <div class="header row">
        <h2>Databases</h2>
        <div class="buttons row">
          <button matButton="filled" (click)="addDatabase()">
            <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
            Add Database
          </button>
          <button matButton="outlined">
            <fa-icon [icon]="['fab', 'php']" size="lg"></fa-icon>
            Install phpMyAdmin
          </button>
        </div>
      </div>

      <mat-card appearance="outlined" class="databases-table-container">
        <app-table
          #table
          [columns]="databasesColumns"
          [dataSource]="records"
          [totalCount]="records.length || 0"
          (pageChange)="handlePageEvent($event)"
          [expandableRows]="true"
        >
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [status]="toStatus(element.status)"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <button
                  matRipple
                  class="button"
                  matTooltip="Database User List"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="table.toggle(element)"
                >
                  <fa-icon [icon]="['fas', 'list-ul']" size="lg"></fa-icon>
                  <span class="users-count">{{ element.users.length }}</span>
                </button>

                <button
                  matRipple
                  class="button"
                  matTooltip="Add Database User"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="addDatabaseUser(element.id)"
                >
                  <fa-icon [icon]="['fas', 'user-plus']" size="lg"></fa-icon>
                </button>
                <button
                  matRipple
                  class="button"
                  matTooltip="Delete Database"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="deleteDatabase(element)"
                >
                  <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <ng-template #expandedRow let-row>
            @if (row.users.length) {
              <div class="expanded-row column">
                <h2>Database Users</h2>
                <div class="inner-table-container">
                  <app-table
                    [columns]="databaseUsersColumns"
                    [dataSource]="row.users"
                    [totalCount]="row.users.length || 0"
                    (pageChange)="handlePageEvent($event)"
                    [showPaginator]="false"
                  >
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                      <td mat-cell *matCellDef="let element">
                        <app-status-label [status]="toStatus(element.status)"></app-status-label>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="buttons">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                      <td mat-cell *matCellDef="let element">
                        <div class="buttons">
                          <button
                            matRipple
                            class="button"
                            matTooltip="Database User Settings"
                            [matTooltipShowDelay]="500"
                            matTooltipPosition="above"
                            (click)="editDatabaseUser(element, row.id)"
                          >
                            <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
                          </button>
                          <button
                            matRipple
                            class="button"
                            matTooltip="Delete Database User"
                            [matTooltipShowDelay]="500"
                            matTooltipPosition="above"
                            (click)="deleteDatabaseUser(element)"
                          >
                            <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                          </button>
                        </div>
                      </td> </ng-container
                  ></app-table>
                </div>
              </div>
            }
          </ng-template>
        </app-table>
      </mat-card>
    </div>
  }
</div>
